import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { FeatureToggleService } from '../../feature-toggle/feature-toggle.service';
import { LoggerService } from '../../logger/logger.service';
import { CommonService } from '../../common/common.service';
import { EMPTY } from 'rxjs';
import { DashboardService } from '../../dashboard/dashboard.service';
import { FeatureStatus } from 'src/app/data-models/common/feature-status.model';
import { SessionStorageKey } from 'src/app/enums/session-storage-key-enum';
import { Microphone } from '../../../data-models/audio/microphone.model';
import { MicrophoneCapabilityService } from './capability/microphone-capability.service';
@Injectable({
	providedIn: 'root',
})
export class MicrophoneService {
	constructor(
		private featureToggleService: FeatureToggleService,
		private logger: LoggerService,
		private commonService: CommonService,
		private dashboardService: DashboardService,
		private microphoneCapability: MicrophoneCapabilityService
	) {}

	public getFeatureToggle(): boolean {
		return this.featureToggleService.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.MicrophoneSettings
		);
	}

	public getCapability(): Promise<boolean> {
		return this.microphoneCapability.get();
	}

	public updateCapabilityCache(properties: Microphone, modes: string[]) {
		this.microphoneCapability.updateCache(properties, modes);
	}

	public setStatus(status: boolean) {
		if (!this.dashboardService.isShellAvailable) {
			return;
		}
		this.dashboardService
			.setMicrophoneStatus(status)
			.then((value: boolean) => {
				this.updateStatusCache(status);
				this.logger.info('microphone setStatus', value);
			})
			.catch((error) => {
				this.logger.error('microphone setStatus', error.message);
				return EMPTY;
			});
	}

	private updateStatusCache(status: boolean) {
		const microphoneStatus: FeatureStatus = this.commonService.getSessionStorageValue(
			SessionStorageKey.DashboardMicrophone
		);
		microphoneStatus.status = status;
		this.commonService.setSessionStorageValue(
			SessionStorageKey.DashboardMicrophone,
			microphoneStatus
		);
	}
}
